import { useState, useEffect, useRef } from 'react';
import TooltipArrow from '../../../img/icons/tooltip-arrow.svg';
import styles from './tooltip.module.css';

export default function Tooltip ({
  icon = null,
  label = null,
  content,
  isHover = true,
  positionX = 'left', // Valid options "left", "centre", "right"
  positionY = 'bottom', // Valid options "top", "bottom",
  statusOverride,
  showToolTipArrow = true
}) {
  const [isActive, setIsActive] = useState(false);
  const [positionStyling, setPositionStyling] = useState({
    transform: '',
    top: '22px',
    bottom: '',
    right: '4px',
    left: ''
  });

  const [arrowPosition, setArrowPosition] = useState([]);

  const wrapperRef = useRef(null);

  useEffect(() => {
    function handleClickOutside (event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsActive(false);
      }
    }

    function handleKeydown (event) {
      if (event.key === 'Escape') {
        setIsActive(false);
      }
    }

    document.addEventListener('keydown', handleKeydown);
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('keydown', handleKeydown);
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    // Control position of content box
    if (positionX === 'left') {
      arrowPosition.push(`${styles.tooltipArrowLeft}`);
      setArrowPosition(arrowPosition);
    }

    if (positionX === 'centre') {
      setPositionStyling((prevData) => ({
        ...prevData,
        right: '50%',
        transform: 'translateX(50%)'
      }));

      arrowPosition.push(`${styles.tooltipArrowCentre}`);
      setArrowPosition(arrowPosition);
    }

    if (positionX === 'right') {
      setPositionStyling((prevData) => ({
        ...prevData,
        transform: '',
        left: '100%',
        right: ''
      }));
      arrowPosition.push(`${styles.tooltipArrowRight}`);
      setArrowPosition(arrowPosition);
    }

    if (positionY === 'top') {
      setPositionStyling((prevData) => ({
        ...prevData,
        bottom: '101%',
        top: ''
      }));
      arrowPosition.push(`${styles.tooltipArrowBottom}`);
      setArrowPosition(arrowPosition);
    }

    if (positionY === 'bottom') {
      arrowPosition.push(`${styles.tooltipArrowTop}`);
      setArrowPosition(arrowPosition);
    }
  }, []);

  useEffect(() => {
    if (statusOverride !== null) {
      setIsActive(statusOverride);
    }
  }, [statusOverride]);

  return (
    <div className={styles.tooltipContainer} ref={wrapperRef}>
      {isActive && (
        <>
          <div className={styles.contentBox} style={positionStyling}>
            {content}
            {!isHover && (
              <button
                type='button'
                onClick={() => setIsActive(false)}
                className={styles.closeButton}
              >
                OK
              </button>
            )}
          </div>
          {showToolTipArrow &&
            <TooltipArrow
              className={`${arrowPosition.join(' ')} ${styles.tooltipArrow}`}
            />}
        </>
      )}
      {isHover ? ( // Hover variant
        <button
          type='button'
          className={styles.tooltip}
          id='tooltip-hover'
          onMouseEnter={() => setIsActive(true)}
          onMouseLeave={() => setIsActive(false)}
        >
          {icon != null && icon}
          {label != null && label}
        </button>
      ) : (
        // Click/press variant
        <button
          type='button'
          id='tooltip-click'
          className={styles.tooltip}
          onClick={() => setIsActive(!isActive)}
        >
          {icon != null && icon}
          {label != null && label}
        </button>
      )}
    </div>
  );
}
